import React from 'react'
import { Button } from 'antd'
import './index.css'

const ButtonWhite = ({
  buttonText = 'Submit',
  loading = false,
  disabled = false,
  htmlType = 'submit',
  holderStyles = {},
  buttonStyles = {},
  onClick = () => {},
}) => {
  return (
    <div style={holderStyles} className="button-holder-white">
      <Button
        type="primary"
        htmlType={htmlType}
        onClick={onClick}
        loading={loading}
        disabled={disabled}
        style={buttonStyles}
      >
        {buttonText}
      </Button>
    </div>
  )
}

export default ButtonWhite
